// extracted by mini-css-extract-plugin
export var icon = "_wy-0";